<template>
  <div>
    <van-cell-group title="节目">
      <van-cell
        title="播放记录"
        icon="todo-list-o"
        is-link
        @click="playHistory"
      />
      <van-cell
        title="我购买的私房课"
        icon="gem-o"
        is-link
        @click="purchase"
      />
    </van-cell-group>
    <van-cell-group title="礼品卡">
      <van-cell
        title="我购买的礼品卡"
        icon="gift-o"
        is-link
        @click="giftCardsMine"
      />
      <van-cell
        title="我收到的礼品卡"
        icon="gift-card-o"
        is-link
        @click="giftCardsToMe"
      />
    </van-cell-group>
    <van-cell-group title="评论">
      <van-cell
        title="我写的评论"
        icon="edit"
        is-link
        @click="myComments"
      />
      <van-cell
        title="我赞过的"
        icon="good-job-o"
        is-link
        @click="iLikedComments"
      />
      <van-cell
        title="回复我的"
        icon="comment-o"
        value-class="badge"
        is-link
        @click="replyToMeComments"
      >
        <!-- <template slot="right-icon">
          <span class="badge"><van-tag type="danger">3</van-tag></span>
        </template> -->
      </van-cell>
    </van-cell-group>
  </div>
</template>

<script>
  import Vue from 'vue'
  import { Cell, CellGroup } from 'vant'
  import { Toast } from 'vant'
  Vue.use(Cell).use(CellGroup)
  Vue.use(Toast)

  export default {
    props: {
    },
    data () {
      return {
        slug: ''
      }
    },
    components: {
    },
    methods: {
      playHistory () {
        this.$router.replace({
          name: `UserCenterHistory`,
          params: {
            slug: this.slug
          }
        })
      },
      purchase () {
        this.$router.replace({
          name: `UserCenterPurchase`,
          params: {
            slug: this.slug
          }
        })
      },
      giftCardsMine () {
        this.$router.replace({
          name: `UserCenterGiftCardsMine`,
          params: {
            slug: this.slug
          }
        })
      },
      giftCardsToMe () {
        this.$router.replace({
          name: `UserCenterGiftCardsToMe`,
          params: {
            slug: this.slug
          }
        })
      },
      myComments () {
        this.$router.replace({
          name: `UserCenterMyComments`,
          params: {
            slug: this.slug
          }
        })
      },
      iLikedComments () {
        this.$router.replace({
          name: `UserCenterILikedComments`,
          params: {
            slug: this.slug
          }
        })
      },
      replyToMeComments () {
        this.$router.replace({
          name: `UserCenterReplyToMeComments`,
          params: {
            slug: this.slug
          }
        })
      },
      boughtEpisodeList () {
        Toast("功能开发中")
        window.console.log("boughtEpisodeList")
      }
    },
    mounted () {
      this.slug = this.$route.params.slug
    }
  }
</script>

<style lang="css" scoped>
  .badge {
    margin-left: 20px;
    font-weight: bold;
  }
</style>
